import { render, staticRenderFns } from "./PurchaseDemand.vue?vue&type=template&id=2f40c35a&scoped=true&"
import script from "./PurchaseDemand.vue?vue&type=script&lang=js&"
export * from "./PurchaseDemand.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDemand.vue?vue&type=style&index=0&id=2f40c35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40c35a",
  null
  
)

export default component.exports